import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Container } from 'react-bootstrap';
import { NodeHighlightedServiceCard } from 'src/components/NodeHighlightedServiceCard/NodeHighlightedServiceCard';
import { NodeServiceCard } from 'src/components/NodeServiceCard/NodeServiceCard';
import { NodeWideServiceCard } from '../NodeWideServiceCard/NodeWideServiceCard';
import * as classes from './ViewsNodeServiceCards.module.scss';

function ViewsNodeServiceCards() {
  const data = useStaticQuery(graphql`
    {
      allSanityServiceCards(sort: { orderRank: ASC }) {
        nodes {
          _id
          title
          description
          url
          displaySize
          image {
            alt
            image {
              asset {
                gatsbyImageData(layout: FIXED, height: 170, placeholder: BLURRED)
              }
            }
          }
        }
      }
    }
  `);

  const {
    allSanityServiceCards: { nodes: cards },
  } = data;

  const getComponentBySize = (card) => ({
    '1x1': <NodeServiceCard card={card} key={card.id} />,
    '2x2': <NodeHighlightedServiceCard card={card} key={card.id} />,
    '1x3': <NodeWideServiceCard card={card} key={card.id} />,
  });

  return (
    <Container className="pr-xl-3 p-0">
      <div className={classes.grid}>{cards.map((card) => getComponentBySize(card)[card.displaySize])}</div>
    </Container>
  );
}

export default ViewsNodeServiceCards;
